import React from "react";
import { Container, Header } from "semantic-ui-react";
import { useCustomerEstimateContext } from "./CustomerEstimateContext";

const CustomerEstimateDisplay: React.FC = () => {
  const { estimateValue, needsCustomQuote } = useCustomerEstimateContext();

  // Checked FIRST, on purpose: an out-of-area address comes back with no dollar
  // amount, so an `if (!estimateValue) return null` ahead of this would swallow
  // the whole screen and the customer would see nothing at all.
  if (needsCustomQuote) {
    return (
      <Container style={{ marginTop: "2rem", textAlign: "center" }}>
        <Header as="h2">Special Pricing</Header>
        <p style={{ fontSize: "1.1rem", color: "#666" }}>
          We deliver well beyond our standard service area — we just price those
          runs individually. Give us a call and we'll quote you directly.
        </p>
        <a href="tel:+16615664426" style={buttonStyle}>
          📞 Call Us for a Quote
        </a>
      </Container>
    );
  }

  if (!estimateValue) return null;

  return (
    <Container style={{ marginTop: "2rem", textAlign: "center" }}>
      <Header as="h2">Your Estimated Price</Header>
      <p style={{ fontSize: "2.5rem", fontWeight: "bold", color: "#1b1b1b" }}>
        ${estimateValue}
      </p>
      <p style={{ color: "#666", fontSize: "0.95rem" }}>
        This is an estimate based on your location. Final pricing may vary.
      </p>
    </Container>
  );
};

const buttonStyle: React.CSSProperties = {
  display: "inline-block",
  padding: "1rem 2rem",
  fontSize: "1.1rem",
  backgroundColor: "#1b1b1b",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  marginTop: "1rem",
  textDecoration: "none",
};

export default CustomerEstimateDisplay;